<template>
  <CoreImage
    v-if="$device.isMobile"
    alt=""
    class="w-full h-full absolute inset-0"
    format="webp"
    src="/images/lo-hp/section-bg-gradient-mobile.webp"
  />
  <CoreImage
    v-else
    alt=""
    class="w-full h-full absolute inset-0"
    format="webp"
    sizes="md:580px lg:1000px xl:1086px 2xl:1448px"
    src="/images/lo-hp/section-bg-gradient-desktop.webp"
  />
</template>
